@import "@SeemplicityDev/shared/src/design-system/styles/constants.scss";

$tree-line-height: 36px;
$borderless-node-tree-line-height: 32px;

.tree-wrapper {
  @for $i from 1 through 10 {
    .tree-node-level-#{$i} {
      margin-left: calc(33px * #{$i}); //calc(18px * #{$i});
    }
  }

  .tree-node-wrapper {
    display: flex;
    flex-direction: column;
    overflow: hidden;

    &.is-readOnly {
      .tree-node-data:hover {
        cursor: default !important;
        border: 1px solid var(--border-color);
        box-shadow: unset;
        color: var(--primary-text-colors);
      }

      .tree-node-label-container {
        color: var(--primary-text-color) !important;
      }
    }
  }

  .tree-node-action {
    min-width: 0;
    flex: 0 0 0;
    justify-content: center;
    height: 100%;
    align-items: center;
    margin-right: 0;
    background-color: var(--secondary-background-color);
    border-top-right-radius: var(--border-radius-s-m);
    border-bottom-right-radius: var(--border-radius-s-m);
    cursor: pointer;
  }

  .node-branch-border {
    position: relative;

    &:after {
      content: "";
      position: absolute;
      width: 1px;
      border-left: 1px dashed var(--primary-theme-color);
      height: 50px;
      top: 0;
    }

    &.node-branch-border-last {
      &:after {
        height: 25px;
      }
    }
  }

  @for $i from 1 through 10 {
    .tree-node-wrapper-data-#{$i} {
      display: flex;
      flex-flow: column nowrap;

      @for $i from 0 through 10 {
        .node-space-0 {
          margin-left: 15px;
        }

        .node-space-#{$i} {
          margin-left: 33px;
        }

        .node-branch-border-#{$i} {
          margin-left: 33px;
        }
      }
    }
  }

  .tree-node {
    display: flex;
    flex: 1 1 auto;
    height: $tree-line-height;
    margin-top: 6px;

    .checkbox-input-wrap {
      height: 100%;
      line-height: $tree-line-height;
      margin-bottom: 0;
      flex: 0 0 27px;

      input {
        height: $tree-line-height;
      }
    }

    .checkbox-input + .checkbox-label {
      padding-left: 25px;
    }

    &.is-selected {
      .highlight-text-wrap {
        color: var(--main-background-color);
      }

      .tree-node-data {
        background-color: var(--primary-theme-color);
        color: var(--main-background-color);
        border: 1px solid var(--primary-theme-color);

        &.group,
        &.is-root,
        &.unscoped {
          background-color: var(--primary-theme-color);
          color: var(--main-background-color);
          border: 1px solid var(--primary-theme-color);

          .tree-node-action {
            .form-icon-button {
              background-color: var(--primary-theme-color);
              color: var(--main-background-color);
            }
          }
        }

        &:hover {
          .form-button-wrap.is-clean.is-secondary i {
            color: var(--main-background-color);
          }
        }
      }

      .tree-node-action {
        background-color: var(--primary-theme-color);
        color: var(--main-background-color);

        &:hover {
          .seem-icon-edit {
            color: var(--main-background-color);
          }
        }
      }

      .tree-node-data {
        &.is-root.selectable {
          &:hover {
            background: var(--primary-theme-color);
            color: var(--main-background-color);
            .tree-node-action {
              background: var(--primary-theme-color);
              color: var(--main-background-color);
              &:hover {
                background: var(--primary-theme-color);
                color: var(--main-background-color);
              }
            }
          }
        }

        &:hover {
          background: var(--primary-theme-color);
          .tree-node-label-container {
            color: var(--main-background-color);
          }

          .tree-node-edit {
            background: var(--primary-theme-color);
            color: var(--main-background-color);
            &:hover {
              background: var(--primary-theme-color);
              color: var(--main-background-color);
            }
          }
        }
      }

      &:hover {
        .form-icon-button-wrap .form-icon-button {
          color: var(--main-background-color);
        }
      }
    }

    .expandable-indicator {
      display: flex;
      justify-content: center;
      position: relative;
      flex: 0 0 var(--icon-in-input-width-l);
      width: var(--icon-in-input-width-l);
      align-items: center;
      cursor: pointer;
      padding: 0;

      i {
        font-size: var(--icon-size-xs);
        color: var(--text-color-main);
        transition: transform ease-in-out 0.07s;
        transform-origin: center;

        &.is-collapsed {
          transform: rotate(-90deg);
        }
      }

      &.is-expandable-hidden {
        cursor: default;
      }

      .tree-leaf-icon {
        height: 3px;
        width: 3px;
        border-radius: 50%;
        background-color: var(--text-color-strong);
      }

      &:hover {
        i.seem-icon-chevron-down {
          color: var(--text-color-soft);
        }
      }
    }

    .tree-node-data {
      position: relative;
      display: flex;
      align-items: center;
      background-color: var(--secondary-background-color);
      width: calc(100% - 32px);
      height: 100%;
      border-radius: var(--border-radius-s-m);
      font-size: var(--font-size-s);
      @include b2-typography;
      cursor: pointer;
      border: 1px solid var(--border-color);
      flex: 1 1 auto;
      overflow: hidden;
      padding: 0 var(--inline-padding-before-after-icon);

      .tree-node-action-buttons-wrap {
        display: none;
      }

      .tree-node-leading-actions {
        display: flex;
        align-items: center;
        flex: 0 0 auto;
        visibility: hidden;
      }

      &:hover,
      &:focus-within,
      &:has(.filter-preview-trigger[data-state="open"]) {
        .tree-node-action-buttons-wrap {
          display: flex;
        }

        .tree-node-leading-actions {
          visibility: visible;
        }
      }

      &.selectable {
        cursor: pointer;
      }

      &.group {
        background-color: var(--main-background-color);

        .tree-node-action {
          cursor: pointer;
          background-color: var(--main-background-color);
        }
      }

      &.is-root {
        background: var(--main-background-color);
        color: var(--primary-text-color);

        &.not-selectable {
          cursor: default;

          &:hover {
            background-color: var(--secondary-background-color);
          }
        }

        &.selectable {
          &:hover {
            background-color: var(--main-background-color);
          }
        }
      }

      &:hover,
      &:has(.filter-preview-trigger[data-state="open"]) {
        border: 1px solid var(--primary-theme-color);
        .filter-panel-action {
          color: var(--main-background-color);
          &:hover {
            color: var(--link-color-hover);
          }
        }
      }

      &.unscoped {
        background-color: var(--main-background-color);
        border: 1px dashed var(--primary-theme-color);

        &:hover {
          border-style: solid;
        }
      }

      .tree-node-label-container {
        display: flex;
        height: calc(#{$tree-line-height} - 2px);
        align-items: center;
        width: 100%;
        vertical-align: middle;
        padding-right: var(--spacing-1);
        overflow: hidden;

        &.has-left-icon {
          padding-left: 0;
        }

        &.is-editable {
          flex: 1 1 auto;
          max-width: calc(100% - 10px);
        }

        .tree-node-label {
          @include ellipsis(100%);
          user-select: none;
          padding-top: 2px;
          display: flex;
          align-items: center;
          gap: var(--spacing-1);

          span {
            @include ellipsis(100%);
            display: inline;
          }
        }

        .node-warning-icon {
          color: var(--high-alert-bg-color);
          margin-left: auto;
          margin-right: 15px;
          font-size: var(--font-size-xs);
        }

        &:hover {
          color: var(--text-color-soft);
        }
      }

      &.is-root.not-selectable,
      &.not-selectable {
        color: var(--text-color-weak) !important;
        background: var(--main-background-color);
        .tree-node-label-container {
          color: var(--text-color-weak) !important;
        }

        &:hover,
        &:has(.filter-preview-trigger[data-state="open"]) {
          border-color: var(--border-color);
          background: var(--main-background-color);
          cursor: default;
        }
      }
    }

    &:last-child {
      .tree-node-data:after {
        height: 20px;
      }
    }

    .tree-node-icon {
      font-size: var(--icon-size-s);
      line-height: 1;
    }
  }

  .node-branch-border-last {
    height: 25px;
  }

  .tree-node-show-more {
    display: flex;
    align-items: center;
    // Aligns with the label column of the rows above it.
    padding-left: var(--icon-in-input-width-l);
    margin-top: var(--spacing-2);
  }

  &.has-checkbox {
    .tree-node-show-more {
      padding-left: calc(27px + var(--icon-in-input-width-l));
    }
  }

  .tree-node-label-container-icon-wrap {
    flex: 0 0 var(--icon-in-input-width);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: var(--inline-padding-before-after-icon);
  }
}

.tree-wrapper.borderless-nodes {
  .tree-node {
    height: $borderless-node-tree-line-height;

    .checkbox-input-wrap {
      height: $borderless-node-tree-line-height;
      line-height: $borderless-node-tree-line-height;

      input {
        height: $borderless-node-tree-line-height;
      }
    }

    .tree-node-data .tree-node-label-container {
      padding-left: 0;
      height: $borderless-node-tree-line-height;
    }
  }

  .expandable-indicator + .tree-node-data {
    .tree-node-label {
      span > span {
        padding-left: 0;
      }
    }
  }

  @for $i from 1 through 10 {
    .tree-node-level-#{$i} {
      margin-left: calc(25px * (#{$i}));
    }
  }

  .node-branch-border {
    @for $i from 1 through 10 {
      .tree-node-wrapper-data-#{$i} {
        @for $i from 0 through 10 {
          .node-space-#{$i} {
            margin-left: 25px;
          }

          .node-branch-border-#{$i} {
            margin-left: 25px;
          }
        }
      }
    }
  }
}

.tree-wrapper.preview-mode {
  .tree-node {
    .tree-node-label,
    .tree-node-icon {
      color: var(--scope-tree-preview-text-color) !important;
    }

    &.preview-scope {
      .tree-node-data {
        background-color: var(--scope-tree-scope-preview-bg-color);
        border: 1px dashed var(--scope-tree-scope-preview-border-color);
      }
    }

    &.preview-group {
      .tree-node-data {
        background-color: var(--scope-tree-group-preview-bg-color);
        border: 1px dashed var(--scope-tree-group-preview-border-color);
      }
    }

    &.preview-error {
      .tree-node-data {
        background-color: var(--scope-tree-preview-error-bg-color);
        border: 1px dashed var(--scope-tree-preview-error-border-color);
      }
    }
  }
}

.tree-wrapper.is-static {
  .tree-node-wrapper .tree-node {
    .expandable-indicator {
      display: none;
    }

    .tree-node-data {
      width: 100%;
      cursor: default;
    }
  }
}

.tree-wrapper .tree-node-wrapper .tree-node.is-highlighted {
  .tree-node-data,
  .tree-node-data:hover {
    background-color: var(--tree-node-highlighted-bg-color);
    border-color: var(--tree-node-highlighted-border-color);
  }
}

.tree-wrapper .tree-node-label-container.has-right-icon .tree-node-label {
  margin-right: var(--spacing-2);
}
